module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "switch",
    class: _vm.switchOn,
    on: {
      "click": function($event) {
        _vm.toggle()
      }
    }
  }), _c('label', {
    on: {
      "click": function($event) {
        _vm.toggle()
      }
    }
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e878378"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ToggleSwitch.vue
// module id = 1097
// module chunks = 0